<template>
  <div class="fts-login" data-login-load="loading">
    <!-- header -->
    <div class="login-header">
      <div class="login-header-container">
        <img :src="companyLogo" alt="company-logo" class="login-header__logo" />
        <div class="login-header__name">{{ companyName }}</div>
      </div>
    </div>
    <!-- content -->
    <div class="login-content">
      <div class="login-form comfort-form-design" v-if="!error">
        <div class="login-form-title">
          <div class="login-form-title-main">Signing in...</div>
          <div class="login-form-title-sub">Please wait while we complete your authentication.</div>
        </div>
      </div>
      <!-- error -->
      <div class="login-form comfort-form-design" v-else>
        <div class="login-form-title">
          <div class="login-form-title-main">Authentication failed</div>
          <div class="login-form-title-sub">{{ error }}</div>
        </div>
        <fts-btn class="login-form-action" color="primary" text-transform-init box-shadow-none
          @click="goToLogin">
          Back to sign in
        </fts-btn>
      </div>
    </div>
    <!-- footer -->
    <div class="login-footer">
      <div class="app-build-version" v-if="buildVersion">
        version {{ buildVersion }}
      </div>
    </div>
    <!-- spinner -->
    <fts-spinner full-screen v-if="!error" />
  </div>
</template>

<script>
import { authorizationStore } from "../store/authorizationStore";
import { clientStore } from "../store/clientStore";
import LocalStorageService from "../store/LocalStorageService";
import webAppConfig from "../commons/webApp.config";

import FTSSpinner from "../elements/FTSSpinner";
import FTSBtn from "../elements/FTSBtn";

export default {
  name: "auth-callback",
  components: {
    "fts-spinner": FTSSpinner,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    error: null,
    buildVersion: webAppConfig.buildVersion,
  }),
  computed: {
    companyLogo() {
      return authorizationStore.getters.appLogo;
    },
    companyName() {
      return authorizationStore.getters.appName;
    },
  },
  methods: {
    goToLogin() {
      this.$router.replace({ name: "login" });
    },
    async handleCallback() {
      const query = this.$route.query;

      try {
        // Case 1: Direct token callback (accessToken + refreshToken in query)
        if (query.accessToken && query.refreshToken) {
          authorizationStore.dispatch("setAuth", {
            access_token: query.accessToken,
            refresh_token: query.refreshToken,
          });
          await authorizationStore.dispatch("refreshToken");

          if (query.wsId) {
            this.$cookies.set("wsId", query.wsId);
            LocalStorageService.setWorkspaceId(webAppConfig.baseServer, query.wsId);
          }

          this.$router.replace({ name: "dashboard" });
          return;
        }

        // Case 2: OAuth authorization code callback
        const authCode = query.code;
        const provider = query.provider || query.type || query.state;

        if (!authCode) {
          if (query.error) {
            this.error = query.error_description || query.error || "Authentication was denied.";
          } else {
            this.error = "No authorization code or token received.";
          }
          return;
        }

        const response = await authorizationStore.dispatch("externalLogin", {
          authCode: authCode,
          type: provider,
        });

        if (response === true) {
          // Authenticated successfully
          this.$router.replace({ name: "dashboard" });
        } else if (response && response.data && response.data.redirect) {
          location.href = `${window.location.origin}/${response.data.redirect}`;
        } else {
          this.error = "Unable to complete authentication. Please try again.";
        }
      } catch (err) {
        console.error("[AuthCallback]", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.error = err.response.data.message;
        } else if (err.response && err.response.data && err.response.data.error_description) {
          this.error = err.response.data.error_description;
        } else {
          this.error = "Authentication failed. Please try again.";
        }
      }
    },
  },
  async mounted() {
    await webAppConfig.getConfig();
    await this.handleCallback();
  },
};
</script>

<style lang="scss">
@use "./src/assets/scss/components/login";
</style>
